import React, { useEffect, useState } from "react";
import axios from "axios";
import { FiUsers } from "react-icons/fi";
import colors from "../Constant/colors";

const AttendanceNonTeachingStaff = () => {
  const [staffList, setStaffList] = useState([]);
  const [filteredStaff, setFilteredStaff] = useState([]);
  const [todayDate, setTodayDate] = useState(new Date());
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingStaff, setLoadingStaff] = useState(true);
const [designations, setDesignations] = useState([]);
  // Get sessionId from localStorage
  const sessionId = localStorage.getItem("currentSessionId");
 


useEffect(() => {
  axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/allDesignations/getDesignations`, {
    params: { sessionId, type: "Non-Teacher" }
  }).then(res => setDesignations(res.data));
}, [sessionId]);


  useEffect(() => {
    if (!sessionId) {
      alert("Session ID not found in localStorage.");
      return;
    }
    fetchStaff();
  }, [sessionId]);

  useEffect(() => {
    const lower = searchQuery.toLowerCase();
    setFilteredStaff(
      staffList.filter((staff) =>
        staff.name.toLowerCase().includes(lower)
      )
    );
  }, [searchQuery, staffList]);

  // Fetch all staff
  const fetchStaff = async () => {
    setLoadingStaff(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/nonTeachingStaff/getAllNonTeachingStaff`,
        { params: { sessionId } }
      );

      const data = res.data.map((staff) => ({
        ...staff,
        attendance: "Present",
        remarks: "",
      }));

      setStaffList(data);
      setFilteredStaff(data);

      // Fetch today's attendance
      fetchTodayAttendance(data);
    } catch (error) {
      console.error("Error fetching staff:", error);
      if (error.response?.status === 404) {
        alert("Staff data not found (404). Check backend endpoint.");
      } else {
        alert("Failed to fetch staff data.");
      }
    } finally {
      setLoadingStaff(false);
    }
  };

  const fetchTodayAttendance = async (staffData) => {
    try {
      const dateStr = todayDate.toISOString().split("T")[0];
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/nonTeachingStaffAttendances/getByDate`,
        { params: { date: dateStr, sessionId } }
      );

      const attendanceData = res.data;

      const mergedData = staffData.map((staff) => {
        const record = attendanceData.find(
          (r) => r.staffId === staff._id
        );
        return record
          ? { ...staff, attendance: record.status, remarks: record.remark }
          : staff;
      });

      setStaffList(mergedData);
      setFilteredStaff(mergedData);
    } catch (error) {
      console.error("Error fetching today's attendance:", error);
      if (error.response?.status === 404) {
        console.warn("No attendance found for today.");
      } else {
        alert("Failed to fetch today's attendance.");
      }
    }
  };

  const handleAttendanceChange = (id, field, value) => {
    setStaffList((prev) =>
      prev.map((staff) =>
        staff._id === id ? { ...staff, [field]: value } : staff
      )
    );
  };

  const handleSubmit = async () => {
    if (!staffList || staffList.length === 0) {
      alert("No staff data available. Cannot submit attendance.");
      return;
    }

    const payload = {
      date: todayDate,
      staff: staffList.map((s) => ({
        staffId: s._id,
        name: s.name,
        designation: s.designation,
        status: s.attendance,
        remark: s.remarks,
      })),
    };

    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/nonTeachingStaffAttendances/createNonTeachingStaffAttendance`,
        payload,
        { params: { sessionId } }
      );

      alert(res.data.message);
    } catch (error) {
      console.error("Error submitting attendance:", error);
      alert("Failed to submit attendance.");
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    fontSize: "14px",
    padding: "10px",
    border: "1px solid #0C3B6C",
    borderRadius: "8px",
    width: "100%",
    background: "#fff",
  };

  const cardStyle = {
    background: "#ffffff",
    borderRadius: "14px",
    padding: "20px",
    boxShadow: "0 3px 10px rgba(0,0,0,0.12)",
    width: "100%",
  };

  if (loadingStaff) {
    return <div className="min-h-screen p-4 md:p-8">Loading staff data...</div>;
  }

  return (
    <div className="min-h-screen p-4 md:p-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <h1 className="font-bold text-black pb-6 flex items-center gap-3 text-xl md:text-2xl">
          <FiUsers size={32} className="text-blue-600" />
          Non-Teaching Staff Attendance
        </h1>

        <div style={cardStyle}>
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-4">
            <input
              type="text"
              placeholder="Search by Staff Name"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{ ...inputStyle, maxWidth: "300px" }}
            />
            <div className="bg-indigo-100 text-indigo-800 font-semibold px-4 py-2 rounded-lg shadow-sm text-sm md:text-base">
              {todayDate.toLocaleDateString("en-GB")}
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-300 rounded-lg overflow-hidden text-left">
              <thead className="bg-gray-100">
                <tr>
                  <th className="p-3 font-semibold text-sm">Sr. No.</th>
                  <th className="p-3 font-semibold text-sm">Staff Name</th>
                  <th className="p-3 font-semibold text-sm">Designation</th>
                  <th className="p-3 font-semibold text-sm">Attendance</th>
                  <th className="p-3 font-semibold text-sm">Remarks</th>
                </tr>
              </thead>
              <tbody>
                {filteredStaff.map((staff, index) => (
                  <tr
                    key={staff._id}
                    className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                  >
                    <td className="p-2 border-b text-sm">{index + 1}</td>
                    <td className="p-2 border-b text-sm">{staff.name}</td>
<td className="p-2 border-b text-sm">
  {staff.designation?.designationName || "N/A"}
</td>

                    <td className="p-2 border-b text-sm">
                      <select
                        value={staff.attendance}
                        onChange={(e) =>
                          handleAttendanceChange(staff._id, "attendance", e.target.value)
                        }
                        style={inputStyle}
                      >
                        <option value="Present">Present</option>
                        <option value="Absent">Absent</option>
                        <option value="On Leave">On Leave</option>
                        <option value="Late">Late</option>
                      </select>
                    </td>
                    <td className="p-2 border-b text-sm">
                      <input
                        type="text"
                        value={staff.remarks}
                        onChange={(e) =>
                          handleAttendanceChange(staff._id, "remarks", e.target.value)
                        }
                        placeholder="Enter remarks"
                        style={inputStyle}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="text-center mt-6">
            <button
              onClick={handleSubmit}
              disabled={loading}
              className="text-white px-6 py-3 rounded-md font-medium text-base md:text-lg"
              style={{
                background: colors.gradientPrimary,
                opacity: loading ? 0.7 : 1,
                cursor: loading ? "not-allowed" : "pointer",
              }}
            >
              {loading ? "Submitting..." : "Submit Attendance"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendanceNonTeachingStaff;
